import { useDispatch, useSelector } from "react-redux";
import PlayPreviewButton from "../../../../components/PlayPreviewButton";
import TextField from "../../../../components/input-fields/TextField";
import SectionItem from "../../../../components/section/section-item/SectionItem";
import SectionItemSubtitle from "../../../../components/section/section-item/SectionItemSubtitle";
import { updateGreeting } from "../../../../redux/actions/InfoActions";

const ReceptionistOpening = () => {
  const dispatch = useDispatch();
  const { updatedGreeting, greetingError } = useSelector((state) => state.info);

  const updatedVoice = useSelector((state) => state.info.updatedVoice);
  const { agentLanguage, voices } = useSelector((state) => state.info);
  const selectedVoice = voices?.find((voice) => voice.id === updatedVoice);

  const onUpdateGreeting = (value) => {
    dispatch(updateGreeting(value));
  };

  const sectionContent = (
    <div id="greeting-section" className="flex flex-col w-full gap-4">
      <div className="flex flex-col w-full gap-4">
        <SectionItemSubtitle subtitle="Customize the receptionist opening to suit your preferences. Guide the caller on how the receptionist can assist them and end with an invitation to share their request. Click “preview” to hear final result." />
        <div className="flex w-full flex-col md:flex-row justify-start items-start gap-2">
          <TextField
            title="Greeting"
            value={updatedGreeting}
            placeholder={"Type your greeting here..."}
            onChange={onUpdateGreeting}
            lines={2}
            required
            maxCharacters={500}
            errorMessage={greetingError}
            className="w-full"
          />
          <PlayPreviewButton
            voice={selectedVoice?.id}
            className="flex-row md:flex-col"
            textToPlay={updatedGreeting}
            id="greeting"
            disabled={selectedVoice?.enablePreview === false}
            language={selectedVoice?.language || agentLanguage}
          />
        </div>
      </div>
    </div>
  );

  return <SectionItem title="Receptionist opening" content={sectionContent} />;
};

export default ReceptionistOpening;
